// extracted by mini-css-extract-plugin
var _1 = "OAuthAuthorizeView-module__accessContainer--ukyyq";
var _2 = "OAuthAuthorizeView-module__accessItem--jJbmI";
var _3 = "OAuthAuthorizeView-module__animateUploadProgressBarWidth--uOPEE";
var _4 = "OAuthAuthorizeView-module__animatedBackground--J14xh";
var _5 = "OAuthAuthorizeView-module__clientName--z3Civ";
var _6 = "OAuthAuthorizeView-module__description--EQpPV";
var _7 = "OAuthAuthorizeView-module__email--ozqG1";
var _8 = "OAuthAuthorizeView-module__host--JOB3t";
var _9 = "OAuthAuthorizeView-module__loggedIn--xUm3z";
var _a = "OAuthAuthorizeView-module__logoContainer--uJZtd";
export { _1 as "accessContainer", _2 as "accessItem", _3 as "animateUploadProgressBarWidth", _4 as "animatedBackground", _5 as "clientName", _6 as "description", _7 as "email", _8 as "host", _9 as "loggedIn", _a as "logoContainer" }
